import { IMAGES } from "./imagesImports";

export const section7Images = [
    {
        src: IMAGES.DOCUMENTVERIFIED,
        alt: "document-verified-img",
        text: "Certified legal translations"
    },
    {
        src: IMAGES.FOCUS,
        alt: "sitemap-img",
        text: "Legal terminology accuracy"
    },
    {
        src: IMAGES.LOCK,
        alt: "sitemap-img",
        text: "Confidentiality guaranteed"
    },
    {
        src: IMAGES.BRAIN,
        alt: "sitemap-img",
        text: "Human translator oversight"
    },
    {
        src: IMAGES.STARS,
        alt: "sitemap-img",
        text: "High-quality translation results"
    }
];

export const section6Images = [
    {
        src: IMAGES.SITEMAP,
        alt: "sitemap-img",
        text: "A network of expert legal translators with extensive experience"
    },
    {
        src: IMAGES.SCALE,
        alt: "scale-img",
        text: "Translation services for law firms, corporate legal departments, and individuals"
    },
    {
        src: IMAGES.FLASH,
        alt: "flash-img",
        text: "Fast turnaround times with options to expedite your order"
    },
    {
        src: IMAGES.DISCOUNT,
        alt: "discount-img",
        text: "Transparent per-page pricing and competitive rates"
    },
    {
        src: IMAGES.TRNASLATE,
        alt: "translate-img",
        text: "Proven translation accuracy and quality assurance"
    }
];

export const section5Images = [
    {
        src: IMAGES.SHEILDPROFILE,
        alt: "Shield",
        text: "Translation completed by a professional translator"
    },
    {
        src: IMAGES.DOCUMENTVERIFIED,
        alt: "Document verified",
        text: "Certification that the translation is accurate and complete"
    },
    {
        src: IMAGES.DOCUMENT,
        alt: "Document",
        text: "Official company letterhead and certificate of translation accuracy"
    },
    {
        src: IMAGES.PEN,
        alt: "Pen",
        text: "Optional notarization when needed"
    }
];

export const section3Images = [
    {
        src: IMAGES.ASESMENT1,
        alt: "asesment-1",
        heading: 'Upload Your Documents',
        description: 'Use our secure system to upload your documents for a free evaluation',
        backgroundColor: '#F46350'
    },
    {
        src: IMAGES.ASESMENT2,
        alt: "asesment-2",
        heading: 'Request a Quote:',
        description: 'We assess your word count, document complexity, and translator availability to provide an exact quote.',
        backgroundColor: '#7245ED'
    },
    {
        src: IMAGES.ASESMENT3,
        alt: "asesment-3",
        heading: 'Assign Professional Translators',
        description: 'We assign your project to a professional human translator with legal translation experience.',
        backgroundColor: '#12ABBF'
    },
    {
        src: IMAGES.ASESMENT4,
        alt: "asesment-4",
        heading: 'Team Reviews & QA',
        description: 'Our translation team reviews every document for consistency and legal terminology.',
        backgroundColor: '#F46350'
    },
    {
        src: IMAGES.ASESMENT5,
        alt: "asesment-5",
        heading: 'Certification & Delivery',
        description: 'You receive your certified translation with an optional notarized translation if required.',
        backgroundColor: '#7245ED'
    },
];

export const section2Images = [
    {
        src: IMAGES.STAT,
        alt: "stat-1",
        text: 'Translation is essential in the legal industry where even minor errors can lead to significant consequences. Legal documents often require a certified translation to be accepted in legal proceedings. Courts, government agencies, and legal teams demand documents that are translated word-for-word with high accuracy. That’s why our legal document translation services are performed by expert translators with legal expertise, not machine translation.'

    },
    {
        src: IMAGES.STAT2, alt: "stat-2",
        text: 'eVerbary offers certified document translation backed by a certificate of translation accuracy and formatted on official letterhead. We help you meet compliance standards with translations that are clear, complete, and accepted by institutions across the U.S. and abroad.'
    }
];


